import LayoutActividad from "../../../components/LayoutActividad";
import { modulo13 } from "../../../routes/Module13";
import GuiaDocente from "../../../components/GuiaDocente";
import Sidebar from "../Sidebar";
import Imagen1 from "../../../images/modulo13/ciudad.png";
import Imagen2 from "../../../images/modulo13/protesta.png";

const Actividad9 = () => {
  const infoUnidad = modulo13.content[1];
  const infoAct = modulo13.content[1].activities[12];
  const crumbs = [
    {
      title: modulo13.title,
      url: "/" + modulo13.url,
    },
    {
      title:
        modulo13.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];

  const pages = {
    titlePrev: `${modulo13.content[1].name}: ${modulo13.content[1].activities[11].name}`,
    linkPrev: `${modulo13.url}/${modulo13.content[1].path}/${modulo13.content[1].activities[11].path}`,
    titleNext: `${modulo13.content[2].name}: ${modulo13.content[2].activities[0].name}`,
    linkNext: `${modulo13.url}/${modulo13.content[2].path}/${modulo13.content[2].activities[0].path}`,
  };
  const metadata = {
    color: modulo13.color,
    title: `${modulo13.title} - ${infoAct.name}`,
    name: modulo13.title,
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <h2 className="mb-5">{infoAct.name}</h2>

      <div className="bg-light p-3 p-md-5 mt-5">
        <div className="row mt-3 align-items-center">
          <div className="col-md-8 col-12 p-3 p-md-3">
            <h2 className="mb-4">Usando los recursos responsablemente</h2>

            <p>
              A nivel mundial existe mucha <strong>demanda de recursos</strong>{" "}
              como minerales y petróleo. Esto ha hecho que en el Perú se hayan
              generado condiciones favorables para la explotación de dichos
              recursos naturales.
            </p>
          </div>
          <div className="col-md-4 col-12 text-center">
            <img src={Imagen1} className="img-fluid w-100" alt="Peruanos" />
          </div>
          <div className="col-md-4 col-12 text-center">
            <img src={Imagen2} className="img-fluid w-100" alt="Peruanos" />
          </div>
          <div className="col-md-8 col-12 p-4 p-md-3">
            <p>
              Para que lo anterior sea beneficioso para todos los peruanos, es
              importante que las decisiones para la explotación de recursos
              recojan <strong>las opiniones de las poblaciones</strong> que
              habitan en estos territorios. Ello puede evitar la confrontación
              con las empresas extractivas y con el Estado. Además, debe
              asegurar que se adopten medidas para el{" "}
              <strong>cuidado ambiental</strong>.
            </p>
          </div>
        </div>
      </div>

      <GuiaDocente>
        <ul>
          <li>
            Lea el título del texto en voz alta: Usando los recursos
            responsablemente. Pregunte: “¿Qué significa el uso responsable de
            recursos?”. Apunte algunas respuestas. Pida que lean en voz alta,
            por turnos, el texto.
          </li>
          <li>
            Ahora vuelva a realizar la pregunta “¿Qué significa el uso
            responsable de recursos?”. Contraste las nuevas respuestas con
            aquellas apuntadas. Deje claro que con el uso responsable de
            recursos se busca que estos no afecten innecesariamente el medio
            ambiente. Asimismo, se busca que su uso beneficie a todos, incluidas
            las poblaciones locales.
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad9;
